import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import { AvForm, AvField } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import CustomCheckbox from "../merchants-users/components/CustomCheckbox";

export default class ApplicationSetup extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      loading: false,
      searchRadiusKm: 10,
      reviewsEnabled: true,
      quotationEnabled: true,
      success: "",
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const response = await this.engine.getItem("app-settings");
    if (response && response.status === 200 && response.data) {
      this.setState({
        searchRadiusKm: response.data.searchRadiusKm ?? 10,
        reviewsEnabled: response.data.reviewsEnabled ?? true,
        quotationEnabled: response.data.quotationEnabled ?? true,
        isLoading: false,
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  handleValidSubmit = async () => {
    this.setState({ loading: true, success: "" });
    const { searchRadiusKm, reviewsEnabled, quotationEnabled } = this.state;

    try {
      const response = await this.engine.putPath("app-settings", {
        searchRadiusKm: parseInt(searchRadiusKm, 10),
        reviewsEnabled,
        quotationEnabled,
      });
      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ success: "Settings saved successfully." });
      }
    } catch (err) {
      const msg = err.response?.data?.message;
      alert(Array.isArray(msg) ? msg.join(", ") : "An error occurred: " + err.message);
    }

    this.setState({ loading: false });
  };

  render() {
    const {
      loading,
      isLoading,
      searchRadiusKm,
      reviewsEnabled,
      quotationEnabled,
      success,
    } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="8">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">
                    {strings.application_setup || "Application Setup"}
                  </CardTitle>
                  <p className="text-muted mb-0">
                    Global settings that control how the mobile app behaves.
                  </p>
                </CardHeader>
                <CardBody>
                  {success && (
                    <div className="alert alert-success">{success}</div>
                  )}

                  <AvField
                    label={strings.search_radius_km || "Search Radius (km)"}
                    name="searchRadiusKm"
                    type="number"
                    value={searchRadiusKm}
                    helpMessage="Distance used when the app searches for nearby garages."
                    onChange={(e) =>
                      this.setState({ searchRadiusKm: e.target.value })
                    }
                    validate={{
                      required: { value: true },
                      min: { value: 1 },
                    }}
                  />

                  <div className="mt-3">
                    <CustomCheckbox
                      label={
                        strings.enable_reviews || "Enable reviews in app"
                      }
                      isChecked={!!reviewsEnabled}
                      onChange={(e) =>
                        this.setState({ reviewsEnabled: e.target.checked })
                      }
                    />
                    <small className="text-muted">
                      When disabled, clients won't see garage reviews in the app.
                    </small>
                  </div>

                  <div className="mt-3">
                    <CustomCheckbox
                      label={strings.enable_quotation || "Show quotation step"}
                      isChecked={!!quotationEnabled}
                      onChange={(e) =>
                        this.setState({ quotationEnabled: e.target.checked })
                      }
                    />
                    <small className="text-muted">
                      When disabled, "Book Now" skips the quotation screen and
                      goes straight to picking a date.
                    </small>
                  </div>
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
